import { CancelOutlined } from "@mui/icons-material";
import { Alert } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { devLog } from "utils/devLog";

const searchTypeMap = new Map();

export default function EFGMemberSearchForm(props) {
  const NAME = "NAME";
  const PHONE_NUMBER = "PHONE_NUMBER";
  const LAST8_VIN = "LAST8_VIN";
  const MEMBER_NUMBER = "MEMBER_NUMBER";

  const { t } = useTranslation();
  const formRef = useRef();
  const [firstName, setFirstName] = useState(props.currState.MemberLookup.firstName || props.currState.FirstName || "");
  const [lastName, setLastName] = useState(props.currState.MemberLookup.lastName || props.currState.LastName || "");
  const [memberNumber, setMemberNumber] = useState(
    props.currState.MemberLookup.memberNumber || props.currState.memberNumber || "",
  );
  const [phoneNumber, setPhoneNumber] = useState(
    props.currState.MemberLookup.phoneNumber || props.currState?.Number?.replace(/\D/g, "") || "",
  );
  const [last8Vin, setLast8Vin] = useState(props.currState.MemberLookup.last8Vin || props.currState.last8Vin || "");
  const [lessThan7, setLessThan7] = useState(false);

  const [searchTypes, setSearchTypes] = useState([
    { key: NAME, value: t("description.Name") },
    { key: PHONE_NUMBER, value: t("description.ConfirmCustomerPhoneNumber") },
    { key: LAST8_VIN, value: t("description.ConfirmCustomerLast8VIN1") },
    { key: MEMBER_NUMBER, value: t("FIMC.ContractSearch.DropdownOptions1") },
  ]);

  const [selectedSearchType, setSelectedSearchType] = useState(props.currState.MemberLookup?.searchType || NAME);

  useEffect(() => {
    setFirstName(firstName);
    setLastName(lastName);
    setPhoneNumber(phoneNumber);
    setMemberNumber(memberNumber);
    setLast8Vin(last8Vin);
  }, [selectedSearchType]);

  useEffect(() => {
    if (typeof props.onFormUpdated === "function") {
      props.onFormUpdated({
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
        last8Vin: last8Vin,
        memberNumber: memberNumber,
        searchType: selectedSearchType,
      });
    }
  }, []);

  const onSubmit = (e) => {
    devLog("onSubmit", e);
    e.preventDefault();

    if (typeof props.onFormSubmit === "function") {
      props.onFormSubmit({
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
        memberNumber: memberNumber,
        last8Vin: last8Vin,
        searchType: selectedSearchType,
      });
    }
    return false;
  };

  const memberNumberLimit = (e) => {
    if (e.target.value.length > 7) {
      e.target.value = e.target.value.slice(0, -1);
      devLog("Vin Length error");
    }
  };

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const windowWidth = () => {
    if (width < 720) {
      return "group-1 group-v2 input-v2";
    } else {
      return "group-1";
    }
  };

  const windowWidth2 = () => {
    if (width < 720) {
      return "label label-v2";
    } else {
      return "label";
    }
  };

  return (
    <>
      <div className="formContainer">
        <form ref={formRef} onSubmit={onSubmit} className="form">
          <Dropdown
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <Dropdown.Toggle style={{ color: "white" }} variant="dark" id="dropdown-basic">
              {searchTypes.find((opt) => opt.key === selectedSearchType)?.value}
            </Dropdown.Toggle>
            <Dropdown.Menu variant="dark">
              {searchTypes.map((searchType) => {
                return (
                  <Dropdown.Item
                    active={searchType.key === selectedSearchType}
                    onClick={(e) => setSelectedSearchType(searchType.key)}
                  >
                    {searchType.value}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>

          {/*FIRST NAME*/}
          {selectedSearchType === NAME && (
            <>
              <div className={windowWidth()}>
                <div className={windowWidth2()}>{t("description.ConfirmCustomerFirstName")}:</div>
                <input
                  type="string"
                  placeholder="ex: JOHN"
                  name="firstName"
                  className="input form-control required"
                  value={firstName}
                  onChange={(e) => {
                    setFirstName(e.target.value?.trim()?.toUpperCase() || "");
                  }}
                  required={true}
                />
              </div>
            </>
          )}

          {/*LAST NAME*/}
          {selectedSearchType === NAME && (
            <>
              <div className={windowWidth()}>
                <div className={windowWidth2()}>{t("description.ConfirmCustomerLastName")}:</div>
                <input
                  type="string"
                  placeholder="ex: DOE"
                  name="lastName"
                  className="input form-control required"
                  value={lastName}
                  onChange={(e) => {
                    setLastName(e.target.value?.trim()?.toUpperCase() || "");
                  }}
                  required={true}
                />
              </div>
            </>
          )}

          {/*POSTAL CODE*/}
          {/* {selectedSearchType === NAME && (
            <>
              <div className="group-1">
                <div className="label">
                  {t("description.ConfirmCustomerPostalCode")}:
                </div>
                <input
                  type="number"
                  placeholder={t("description.ConfirmCustomerPostalCode")}
                  name="postalCode"
                  className="input form-control required"
                  value={postalCode}
                  onChange={(e) => {
                    setPostalCode(e.target.value?.trim()?.toUpperCase() || "");
                  }}
                  required={true}
                />
              </div>
            </>
          )} */}

          {/*PHONE_NUMBER*/}
          {selectedSearchType === PHONE_NUMBER && (
            <>
              <div className={windowWidth()}>
                <div className={windowWidth2()}>{t("FIMC.ContractSearch.DropdownOptions5")}:</div>
                <input
                  type="number"
                  placeholder="ex: 123-456-7890"
                  name="phoneNumber"
                  className="input form-control required"
                  value={phoneNumber}
                  onChange={(e) => {
                    setPhoneNumber(e.target.value?.trim() || "");
                  }}
                  required={true}
                />
              </div>
            </>
          )}

          {/*Last 8 Vin*/}
          {selectedSearchType === LAST8_VIN && (
            <>
              <div className={windowWidth()}>
                <div className={windowWidth2()}>{t("description.ConfirmCustomerLast8VIN1")}:</div>
                <input
                  type="string"
                  placeholder="ex: ABC12345"
                  name="last8Vin"
                  className="input form-control required"
                  value={last8Vin}
                  onChange={(e) => {
                    setLast8Vin(e.target.value?.trim() || "");
                  }}
                  required={true}
                />
              </div>
            </>
          )}

          {/*Member Number*/}
          {selectedSearchType === MEMBER_NUMBER && (
            <>
              <div className={windowWidth()}>
                <div className={windowWidth2()}>{t("FIMC.ContractSearch.DropdownOptions1")}:</div>
                <input
                  type="string"
                  placeholder="ex: 12345678901"
                  name="memberNumber"
                  className="input form-control required"
                  value={memberNumber}
                  onChange={(e) => {
                    setMemberNumber(e.target.value?.trim() || "");
                  }}
                  required={true}
                />
              </div>
            </>
          )}

          <div className="footerContainer">
            <div>
              <button
                id="cancelButton"
                type="button"
                className="footer"
                style={{
                  background: "#f4f4f4",
                  color: "black",
                  paddingLeft: 14,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  devLog("UI Cancel pressed");
                  if (typeof props.onUserCancel === "function") {
                    props.onUserCancel();
                  }
                }}
              >
                <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
              </button>
            </div>
            <button type="submit" className="ui-btn">
              {t("description.ConfirmCustomerSubmit")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
